import { createRouter, createWebHistory } from "vue-router";
import AppRouter from "@/Routers/AppRouter"
import AdminRouter from "@/Routers/AdminRouter";

const routes = [
  ...AppRouter,
  ...AdminRouter
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

export default router